import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import OutboundExpiryReportActions from '../../Stores/OutboundExpiryReport/Actions';

const { Panel } = Collapse;

class OutboundExpiryReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initOutboundExpiry } = this.props;

    if (curSiteFlowId > 0) {
      initOutboundExpiry();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initOutboundExpiry } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initOutboundExpiry();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'outbound_expiry_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

OutboundExpiryReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initOutboundExpiry: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

OutboundExpiryReportScreen.defaultProps = {
  intl: {},
  match: {},

  initOutboundExpiry: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initOutboundExpiry: () =>
    dispatch(OutboundExpiryReportActions.outboundExpiryReportInitOutboundExpiry())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(OutboundExpiryReportScreen));
